<template>
  <div class="tinymce-editor">
    <editor v-model="myValue" :init="init" :disabled="disabled" @input="editorChange">
    </editor>
  </div>
</template>
<script>
	import tinymce from 'tinymce/tinymce'
	import Editor from '@tinymce/tinymce-vue'
	import 'tinymce/themes/silver'
	// 编辑器插件plugins
	// 更多插件参考：https://www.tiny.cloud/docs/plugins/
	// import 'tinymce/plugins/image'// 插入上传图片插件
	// import 'tinymce/plugins/media'// 插入视频插件
	// import 'tinymce/plugins/table'// 插入表格插件
	// import 'tinymce/plugins/lists'// 列表插件
	// import 'tinymce/plugins/link'

	export default {
		components: {
			Editor
		},
		props: {
			value: {
				type: String,
				default: ''
			},
			// 基本路径，默认为空根目录，如果你的项目发布后的地址为目录形式，
			// 即abc.com/tinymce，baseUrl需要配置成tinymce，不然发布后资源会找不到
			baseUrl: {
				type: String,
				default: '/frontend_m'
			},
			disabled: {
				type: Boolean,
				default: false
			},
			plugins: {
				type: [ String, Array ],
				default: 'lists link'
			},
			toolbar: {
				type: [ String, Array ],
				default: 'undo redo bold italic bullist numlist outdent indent link removeformat'
			},
			placeholder: {
				type: String,
				default: ''
			},
			height: {
				type: Number,
				default: 300
			}
		},
		data () {
			return {
				init: {
					language_url: `${ this.baseUrl }/tinymce/langs/zh_CN.js`,
					language: 'zh_CN',
					skin_url: `${ this.baseUrl }/tinymce/skins/ui/oxide`,
					content_css: `${ this.baseUrl }/tinymce/skins/content/default/content.css`,
					height: this.height,
					plugins: this.plugins,
					toolbar: this.toolbar,
					placeholder: this.placeholder,
					toolbar_sticky: true,
					branding: false,
					menubar: false,
					paste_remove_styles_if_webkit: true,
					paste_remove_styles: true
				},
				myValue: this.value
			}
		},
		mounted () {
			alert(this.props+'mounted')
			// tinymce.init({})
		},
		methods: {},
		watch: {
			value (newValue) {
				this.myValue = newValue
			},
			myValue (newValue) {
				console.log(newValue, '============')
				this.$emit('input', newValue)
			},
			height (value) {
				tinymce.init(this.init)
			}
		}
	}
</script>
<style lang="scss" scoped>
  .tinymce-editor {
    /deep/ .tox-tinymce {
      height: 100% !important;
      border: none;
      box-sizing: border-box;
      .tox-statusbar {
        display: none;
      }
      .tox-toolbar__group {
        width: 100vw;
        display: flex;
        justify-content: space-between;
      }
    }
  }
</style>
